<template>
  <div>
    <transition-group tag="div" class="notification-group" name="notification">
      <div v-for="notification in notifications" :key="notification.id">
        <c-notification-bar :notification="notification"></c-notification-bar>
      </div>
    </transition-group>
  </div>
</template>

<script>
import CNotificationBar from "@/components/CNotificationBar.vue";
import { mapState } from "vuex";

export default {
  name: "CNotificationContainer",
  data() {
    return {};
  },
  components: {
    CNotificationBar
  },
  computed: {
    ...mapState("notification", ["notifications"])
  }
  // watch: {
  //   notifications(open) {
  //     open.forEach((o) => {
  //       if (!o.timeout) {
  //         o.timeout = setTimeout(() => {
  //           this.notifications.splice(this.notifications.indexOf(o), 1)
  //         }, o.delay ? o.delay : 2000)
  //       }
  //     });
  //   }
  // }
};
</script>

<style>
.notification-group {
  position: fixed;
  z-index: 999999;
  bottom: 0;
  right: 0;
  padding: 10px;
  display: flex;
  flex-direction: column-reverse;
}

.notification {
  /* background: #64a2ff; */
  color: #fff;
  border-radius: 5px;
  padding: 15px;
  margin-top: 5px;
  font-size: 0.8em;
}

.notification-enter-active {
  opacity: 0.8;
  transform: translate(100%);
  transition: 0.5s;
}

.notification-enter-to {
  opacity: 1;
  transform: translate(0);
}

.notification-leave-active {
  opacity: 1;
  transform: translate(0);
  transition: 0.5s;
}

.notification-leave-to {
  opacity: 0;
  transform: translate(100%);
}
</style>
